import React, { Component } from 'react';

import Chart from "react-apexcharts";

import { postDashboardForm } from '../api/apiClient'

import { Circles } from 'react-loader-spinner'
import { ROCELL_COLORS } from '../theme/rocellTheme';
import { buildPieChartOptions } from '../theme/chartOptions';



export class TTCPCchart extends Component {

    constructor() {

        super()

        this.state = {

            options: {

                chart: {

                    type: "pie"

                },

                labels: [''],

                legend: { position: 'bottom' },

            },

            series: [],

            isLoaded: false,

            hasChartData: false,

            filterDateTo: '',

            filterDateFrom: '',

            filterSupplier: '',

            filterVehicleType: '',

            suppliers: [],

            vehicleTypes: [

                { id: '', name: 'All' },

                { id: '1', name: '3 Pallet' },

                { id: '2', name: '6 Pallet' },

                { id: '4', name: '8 Pallet' },

                { id: '6', name: '10 Pallet' },

                { id: '7', name: '15 Pallet' },

                { id: '8', name: '35 Pallet' },

            ],

        };



        this.componentDidMount = this.componentDidMount.bind(this)

        this.filterChange = this.filterChange.bind(this)

        this.updateChart = this.updateChart.bind(this)

    }



    buildChartOptions(labels) {
        return buildPieChartOptions(labels, {
            tooltip: {
                y: {
                    formatter(val) {
                        return `Rs. ${Number(val).toLocaleString('en-LK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                    },
                },
            },
        });
    }



    filterChange(key, event) {

        if (key == 'to') {

            this.setState({ filterDateTo: event.target.value })

        } else if (key == 'from') {

            this.setState({ filterDateFrom: event.target.value })

        } else if (key == 'filterSupplier') {

            this.setState({ filterSupplier: event.target.value })

        } else if (key == 'filterVehicleType') {

            this.setState({ filterVehicleType: event.target.value })

        }

    }



    updateLoader(stateValue) {

        if (this.state.isLoaded === true) {

            this.setState({ isLoaded: false })

        } else {

            this.setState({ isLoaded: stateValue })

        }

    }



    getData(formData) {

        const API_URL = process.env.REACT_APP_API_URL

        const dataUrl = API_URL + "/Bi_dashboard_ttc_pc";



        postDashboardForm(dataUrl, formData).then((response) => {

            if (response.data.success) {

                const reportData = response.data.data || [];

                const isSupplierView = reportData.length > 0 && reportData[0].sup_id !== undefined;

                const chartData = reportData.filter(item => Number(item.tms_shp_trip_cost) > 0);



                const data_record = [];

                const data_name = [];



                chartData.forEach(item => {

                    data_record.push(Number(item.tms_shp_trip_cost));

                    data_name.push(item.sup_name || item.veh_no);

                });



                const nextState = {

                    series: data_record,

                    options: this.buildChartOptions(data_name),

                    isLoaded: true,

                    hasChartData: chartData.length > 0,

                };



                if (isSupplierView) {

                    nextState.suppliers = chartData.map(item => ({

                        sup_id: item.sup_id,

                        sup_name: item.sup_name,

                    }));

                }



                this.setState(nextState);

            } else {

                this.setState({

                    series: [],

                    options: this.buildChartOptions([]),

                    isLoaded: true,

                    hasChartData: false,

                });

            }



        }).catch(function (error) {

            console.log(error);

            this.setState({

                series: [],

                options: this.buildChartOptions([]),

                isLoaded: true,

                hasChartData: false,

            });

        }.bind(this));

    }



    updateChart() {

        const newToDate = this.state.filterDateTo;

        const newFromDate = this.state.filterDateFrom;

        const supplier = this.state.filterSupplier;

        const vehicleType = this.state.filterVehicleType;



        const formData = new FormData();

        formData.append('filter_date_from', newFromDate);

        formData.append('filter_date_to', newToDate);

        formData.append('supplier_id', supplier);

        formData.append('vehicle_type_id', vehicleType);

        this.setState({ isLoaded: false })

        this.getData(formData);

    }



    componentDidMount() {

        const formData = new FormData();



        var currentDate = new Date();

        currentDate = new Date(currentDate.getTime() - 86400000);

        var formattedDateFrom = currentDate.toISOString().split('T')[0];



        currentDate = new Date();

        var formattedDateTo = currentDate.toISOString().split('T')[0];



        formData.append('filter_date_from', formattedDateFrom);

        formData.append('filter_date_to', formattedDateTo);

        formData.append('supplier_id', '');

        formData.append('vehicle_type_id', '');



        this.setState({

            filterDateFrom: formattedDateFrom,

            filterDateTo: formattedDateTo,

            filterSupplier: '',

            filterVehicleType: '',

        })

        this.getData(formData);

    }



    render() {
        return (
            <div className='card bi-chart-card'>
                <div className='card-header border-0'>
                    <div className='row align-items-center'>
                        <div className='col-lg-5'>
                            <p className='card-title mb-0'>
                                <span className='card-label fw-bold'>
                                    Total Transport Cost — Breakdown
                                    <span className='bi-date-muted d-block mt-1'>{this.state.filterDateFrom} to {this.state.filterDateTo}</span>
                                </span>
                            </p>
                        </div>
                        <div className='col-lg-7 bi-chart-actions mt-3 mt-lg-0'>
                            <button
                                type='button'
                                className='btn btn-sm btn-light-primary'
                                data-kt-menu-trigger='click'
                                data-kt-menu-placement='bottom-end'
                                data-kt-menu-flip='top-end'>
                                <i className='fas fa-filter me-1'></i> Filter
                            </button>

                            <div className='menu menu-sub menu-sub-dropdown w-250px w-md-300px' data-kt-menu='true'>
                                <div className='px-7 py-5'>
                                    <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
                                </div>

                                <div className='separator border-gray-200'></div>

                                <div className='px-7 py-5'>
                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter From Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDateFrom}
                                                onChange={(event) => this.filterChange('from', event)}
                                                className='form-control' />
                                        </div>
                                    </div>

                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter To Date:</label>
                                        <div>
                                            <input type="Date" name='date' value={this.state.filterDateTo}
                                                onChange={(event) => this.filterChange('to', event)}
                                                className='form-control' />
                                        </div>
                                    </div>

                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter Supplier:</label>
                                        <div>
                                            <select name='suppliers' id='suppliers' className='form-control'
                                                value={this.state.filterSupplier}
                                                onChange={(event) => this.filterChange('filterSupplier', event)}>
                                                <option value="">All</option>
                                                {this.state.suppliers.map((supplier) => (
                                                    <option key={supplier.sup_id} value={supplier.sup_id}>
                                                        {supplier.sup_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className='mb-10'>
                                        <label className='form-label fw-bold'>Filter Vehicle Type:</label>
                                        <div>
                                            <select name='vehicleTypes' id='vehicleTypes' className='form-control'
                                                value={this.state.filterVehicleType}
                                                onChange={(event) => this.filterChange('filterVehicleType', event)}>
                                                {this.state.vehicleTypes.map((vehicleType) => (
                                                    <option key={vehicleType.id || 'all'} value={vehicleType.id}>
                                                        {vehicleType.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className='d-flex justify-content-end'>
                                        <button
                                            type='reset'
                                            className='btn btn-sm btn-white btn-active-light-primary me-2'
                                            data-kt-menu-dismiss='true'>
                                            Reset
                                        </button>

                                        <button type='submit' className='btn btn-sm btn-primary' data-kt-menu-dismiss='true' onClick={this.updateChart}>
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='card-body'>
                    <div className={`bi-chart-area bi-chart-area--pie${!this.state.isLoaded ? ' bi-chart-area--loading' : ''}`}>
                        {!this.state.isLoaded ? (
                            <Circles
                                height="80"
                                width="80"
                                color={ROCELL_COLORS.primary}
                                ariaLabel="circles-loading"
                                visible={true}
                            />
                        ) : this.state.hasChartData ? (
                            <Chart
                                key={`${this.state.filterDateFrom}-${this.state.filterDateTo}-${this.state.filterSupplier}-${this.state.filterVehicleType}-${(this.state.options.labels || []).join('|')}`}
                                options={this.state.options}
                                series={this.state.series}
                                type="donut"
                                width="100%"
                                height={440}
                            />
                        ) : (
                            <div className='bi-date-muted'>No data</div>
                        )}
                    </div>
                </div>
            </div>
        )
    }

}


